<template>
  <div class="error-page">
    <div class="dialog">
      <div>
        <div class="logo">
          <a href="/">
            <KkIcon class="logoIcon" :name="logoName" />
          </a>
        </div>
        <h1>404 Not Found</h1>
        <p />
      </div>
      <p>指定されたページが見つかりません</p>
    </div>
  </div>
</template>

<script>
import { KkIcon } from '../components/base'
import { KCOM_URLS, LOCALONE_URLS, RETTY_URLS } from '../modules/urls'

export default {
  name: 'Page404',
  components: {
    KkIcon,
  },
  computed: {
    logoName() {
      if(KCOM_URLS.some(url => document.domain.includes(url))) return 'logoBlack'
      if(LOCALONE_URLS.some(url => document.domain.includes(url))) return 'logoLocalOne'
      if(RETTY_URLS.some(url => document.domain.includes(url))) return 'logoRetty'
      return ''
    }
  }
}
</script>

<style scoped>
.error-page {
  background-color: #F8F9FA;
  color: #2E2F30;
  text-align: center;
  font-family: arial, sans-serif;
  margin: 0;
}
.error-page div.dialog {
  width: 95%;
  max-width: 33em;
  margin: 4em auto 0;
}
.error-page div.dialog > div {
  border: 1px solid #CCC;
  border-right-color: #E4E7EB;
  border-left-color: #E4E7EB;
  border-bottom-color: #E4E7EB;
  border-top: #E9446A solid 4px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  background-color: white;
  padding: 7px 12% 0;
  box-shadow: 0 3px 8px rgba(50, 50, 50, 0.17);
}
.error-page .logo {
  padding: 30px 0 16px 0;
}
.error-page h1 {
  font-size: 100%;
  color: #E9446A;
  line-height: 1.5em;
}
.error-page div.dialog > p {
  margin: 0 0 1em;
  padding: 1em;
  background-color: #F7F7F7;
  border: 1px solid #E4E7EB;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-color: #DADADA;
  color: #666;
  box-shadow: 0 3px 8px rgba(50, 50, 50, 0.17);
}
.logoIcon {
  width: 100px;
  margin: 0 auto;
}
</style>
